import React from "react";
import PropTypes from "prop-types";
import Confirmation from  "../Modals/Confirmation";
import { Loader } from '@cloudpremise/portal_core';
import MDButton from "../MDButton";
import MDBox from "../MDBox";
import MDInput from "../MDInput";
import MDModal from "../MDModal";
import MDSelect from "../MDSelect";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';


const EditBuilderForm = (props) => {
    let defaultState = {
        heading: "",
        conditionalStep: false,
        conditionalStepValue: null,
        conditionalField: null,
        conditionalFieldValue: [],
        conditionalSubField: null,
        conditionalSubFieldValue: null,
        deleteModal: false,
        item: null,
        errorMessage: null
    };
    if(props.item !== null){
        defaultState = {
            ...defaultState,
            ...props.item,
            item: props.item
        };
    }
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    const conditionalField = (state.conditionalField !== null ? state.conditionalField.label : '');
    const conditionalFieldChange = (typeof(state.conditionalField) === "string" ? true : false);
    React.useEffect(() => {
        if(conditionalFieldChange){
            let newState = {};
            const fields = getFields();
            fields.map((field) => {
                if(field.fieldType === 'PICKLIST' || field.fieldType === 'REFERENCE'){
                    if(field.apiName === state.conditionalField){
                        newState['conditionalField'] = {
                            label: field.label,
                            inputValue: state.conditionalField
                        };
                        getPicklist(field).map((option) => {
                            if(option.inputValue === state.conditionalFieldValue){
                                newState['conditionalFieldValue'] = option;
                            }
                        });
                    }
                }
            });
            setState(newState);
        }
    }, [conditionalFieldChange]);
    function handleChange(event, name){
        const value = event.target.value;
        setState({
            [name]: value,
            hasModifiedFields: true
        });
    }
    function isFormValid(){
        const { heading } = state;
        let isValid = true;
        if(heading.length <= 0){
            isValid = false;
        }
        return isValid;
    }
    function onConfirmationModal(status = false){
        setState({
            deleteModal: status
        });
    }
    function getStepOptions(){
        const list = [];
        let currentFormFound = false;
        props.form.map((subForm) => {
            if(currentFormFound || props.item.heading === subForm.heading){
                currentFormFound = true;
                return null;
            }
            list.push({
                label: subForm.heading,
                inputValue: subForm.heading
            });
        });
        return list;
    }
    function getFields(){
        let conditionalStepValue = state.conditionalStepValue;
        if(typeof(conditionalStepValue) === "string"){
            conditionalStepValue = {
                label: conditionalStepValue,
                inputValue: conditionalStepValue
            }
        }
        let fields = [];
        props.form.map((subForm) => {
            if(conditionalStepValue && conditionalStepValue.inputValue === subForm.heading){
                fields = subForm.fields;
                return null;
            }
        });
        return fields;
    }
    function getFieldOptions(){
        const list = [];
        const fields = getFields();
        fields.map((field) => {
            if(field.isDependentPicklist){
                return null;
            }
            if(field.fieldType === 'PICKLIST' || field.fieldType === 'REFERENCE'){
                list.push({
                    label: field.label,
                    inputValue: field.apiName
                });
            }
        });
        return list;
    }
    function getPicklist(field){
        let picklists = field.picklistOptions;
        const isDependentPicklist = field.isDependentPicklist;
        if(isDependentPicklist && field.controllingPicklist.length > 0){
            let fieldValue = state.conditionalFieldValue;
            if(Array.isArray(fieldValue) && fieldValue.length === 1){
                fieldValue = fieldValue[0];
            }
            if(fieldValue && typeof(fieldValue) === "object"){
                fieldValue = fieldValue.label;
            }
            if(fieldValue && picklists.hasOwnProperty(fieldValue)){
                picklists = picklists[fieldValue];
            }
        }
        if(!Array.isArray(picklists)){
            return [];
        }
        const list = [];
        picklists.map(item => {
            // Handle for dependent fields
            if(typeof(item) === "string"){
                list.push({
                    label: item,
                    inputValue: item
                });
                return null;
            }
            let inputValue = item.label;
            if(item.hasOwnProperty("value")){
                inputValue = item.value;
            }
            list.push({
                label: item.label,
                inputValue: inputValue
            });
            return null;
        });
        return list;
    }
    function renderConditionalField(){
        if(state.conditionalField === null){
            return null;
        }
        const fields = getFields();
        let field = null;
        fields.map((item) => {
            if(item.apiName === state.conditionalField.inputValue){
                field = item;
            }
        });
        if(field === null || (field.fieldType !== 'PICKLIST' && field.fieldType !== 'REFERENCE')){
            return null;
        }
        let fieldValue = state['conditionalFieldValue'];
        if(!fieldValue){
            fieldValue = [];
        }
        const options = getPicklist(field);
        // if(fieldValue && typeof(fieldValue) === "object"){
        //     fieldValue = fieldValue.label;
        // }
        return (
            <MDSelect
                defaultValue={fieldValue}
                value={fieldValue}
                required={field.isRequired}
                options={options}
                label={field.label}
                multiple
                onChange={(event, option) => {
                    let newState = {
                        ['conditionalFieldValue']: option,
                        conditionalSubField: null,
                        conditionalSubFieldValue: null
                    };
                    if(field.isDependentPicklist && option !== null){
                        newState['conditionalSubField'] = field.apiName;
                    }
                    setState(newState);
                }}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => {
                      const { key, ...tagProps } = getTagProps({ index });
                      return (
                        <Chip
                          key={key}
                          label={option.label}
                          {...tagProps}
                        />
                      );
                    })
                }
            />
        );
    }
    function renderConditionalSubField(){
        let fieldValue = state.conditionalFieldValue;
        if(Array.isArray(fieldValue) && fieldValue.length === 1){
            fieldValue = fieldValue[0];
        }
        if(fieldValue && typeof(fieldValue) === "object"){
            fieldValue = fieldValue.label;
        }
        if(fieldValue === null){
            return null;
        }
        const fields = getFields();
        let childField = null;
        fields.map((item) => {
            const isDependentPicklist = item.isDependentPicklist;
            if(isDependentPicklist && item.controllingPicklist.length > 0){
                if(fieldValue && fieldValue.length > 0){
                    childField = item;
                }
            }
        });
        if(childField === null){
            return null;
        }
        return renderField(childField, 'conditionalSubFieldValue');
    }
    function renderField(field, stateName){
        let fieldElement = null;
        const fieldType = field.fieldType;
        switch(fieldType){
            case 'PICKLIST':
            case 'REFERENCE':
                let fieldValue = state[stateName];
                const options = getPicklist(field);
                if(fieldValue && typeof(fieldValue) === "object"){
                    fieldValue = fieldValue.label;
                }
                fieldElement = (
                    <MDSelect
                        defaultValue={fieldValue}
                        value={fieldValue}
                        required={field.isRequired}
                        options={options}
                        label={field.label}
                        onChange={(event, option) => {
                            let newState = {
                                [stateName]: option,
                                conditionalSubField: null
                            };
                            if(field.isDependentPicklist && option !== null){
                                newState['conditionalSubField'] = field.apiName;
                            }
                            setState(newState);
                        }}
                    />
                );
                break;
            default:
                break;
        }
        return fieldElement;
    }
    return (
        <MDModal
            open={props.open}
            footer={
                (
                    state.loading ?
                        <Loader color="info" />
                    :
                        <>
                            {
                                state.error && state.errorMessage !== null ?
                                    null
                                :
                                <>
                                    <MDButton key="cancel" variant="gradient" color="light" onClick={() => props.onCancel(state.item)} >
                                        Cancel
                                    </MDButton>
                                    <MDButton key="delete" variant="gradient" color="error" onClick={() => onConfirmationModal(true)} >
                                        Delete
                                    </MDButton>
                                    <MDButton key="save" variant="gradient" color="info" disabled={!isFormValid()} onClick={() => props.onSuccess(state)}>
                                        Save
                                    </MDButton>
                                </>
                            }
                        </>
                )
            }
            onClose={() => props.onCancel(state.item)}
            title={"Edit Form"}
            maxWidth={"450px"}
            width={"450px"}
        >
            <div className="slds-p-around_medium">
                <MDBox mt={2}>
                    <MDInput
                        label="Heading"
                        fullWidth
                        onChange={(event) => handleChange(event, "heading")}
                        value={state.heading}
                    />
                </MDBox>
                {
                    !props.disableConditionalForm ?
                        <MDBox mt={2}>
                            <FormGroup className="field-checkbox">
                                <FormControlLabel
                                    control={<Checkbox checked={state.conditionalStep} />}
                                    label={"Conditional Step?"}
                                    onChange={(event: any) => {
                                        setState({
                                            conditionalStep: event.target.checked,
                                            conditionalStepValue: null,
                                            conditionalField: null,
                                            conditionalFieldValue: null,
                                            conditionalSubField: null,
                                            conditionalSubFieldValue: null,
                                        });
                                    }}
                                />
                            </FormGroup>
                        </MDBox>
                    :
                        null
                }
                {
                    state.conditionalStep ?
                        <MDBox mt={2}>
                            <MDSelect
                                defaultValue={state.conditionalStepValue}
                                value={state.conditionalStepValue}
                                options={getStepOptions()}
                                label={"Parent Step"}
                                onChange={(event, option) => {
                                    setState({
                                        conditionalStepValue: option,
                                        conditionalField: null,
                                        conditionalFieldValue: null,
                                        conditionalSubField: null,
                                        conditionalSubFieldValue: null,
                                    });
                                }}
                            />
                        </MDBox>
                    :
                        null
                }
                {
                    state.conditionalStepValue && (state.conditionalField === null || typeof(state.conditionalField) === "object") ?
                        <MDBox mt={2}>
                            <MDSelect
                                defaultValue={conditionalField}
                                value={conditionalField}
                                options={getFieldOptions()}
                                label={"Field"}
                                onChange={(event, option) => {
                                    setState({
                                        conditionalField: option,
                                        conditionalFieldValue: null,
                                        conditionalSubField: null,
                                        conditionalSubFieldValue: null,
                                    });
                                }}
                            />
                        </MDBox>
                    :
                        null
                }
                {
                    state.conditionalField !== null ?
                        <MDBox mt={2}>
                            {renderConditionalField()}
                        </MDBox>
                    :
                        null
                }
                {
                    Array.isArray(state.conditionalFieldValue) && state.conditionalFieldValue.length === 1 ?
                        <MDBox mt={2}>
                            {renderConditionalSubField()}
                        </MDBox>
                    :
                        null
                }
                {
                    state.deleteModal ?
                        <Confirmation
                            open={state.deleteModal}
                            onCancel={() => onConfirmationModal(false)}
                            onSuccess={props.onDelete}
                            message={"Are you sure you want to delete?"}
                            saving={state.saving}
                            errorMessage={state.errorMessage}
                        />
                    :
                    null
                }
            </div>
        </MDModal>
    )
};

EditBuilderForm.defaultProps = {
    item: null,
    form: null,
    disableConditionalForm: false
}
EditBuilderForm.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    onDelete: PropTypes.func,
    open: PropTypes.bool,
    item: PropTypes.object,
    form: PropTypes.array,
    disableConditionalForm: PropTypes.bool
};

export default EditBuilderForm;